import React from 'react';

import { TableRow } from '../ControlTab/utils';
import { DataTableColumn } from '@/components/DataTable';

export const createTurbineColumns = (): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 120,
    alignCenter: true,
    renderCell: ({ row }) => {
      const numValue = parseFloat(row.value as string);
      if (!isNaN(numValue)) {
        const formattedValue = numValue.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        });
        return (
          <span style={{ color: 'var(--main-blue-color)' }}>
            {formattedValue}
          </span>
        );
      }
      return (
        <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
    }
  }
];

export const createT5Columns = (): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      const numValue = parseFloat(row.value as string);
      if (!isNaN(numValue)) {
        const formattedValue = numValue.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        });
        return (
          <span style={{ color: 'var(--main-blue-color)' }}>
            {formattedValue}
          </span>
        );
      }
      return (
        <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
    }
  }
];

export const createTurbineRows = (initialData: any): TableRow[] => {
  if (!initialData?.turbine || !Array.isArray(initialData.turbine)) return [];
  return initialData.turbine as TableRow[];
};

export const createT5Rows = (initialData: any): TableRow[] => {
  if (!initialData?.t5 || !Array.isArray(initialData.t5)) return [];
  return initialData.t5 as TableRow[];
};

export const createFuelSystemColumns = (
  StatusIndicatorComponent: React.ComponentType<{ status: '0' | '1' }>
): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    needPadding: row =>
      row.value !== '0' && row.value !== '1' && row.unit !== '',
    renderCell: ({ row }) => {
      const numValue = parseFloat(row.value as string);
      if (!isNaN(numValue)) {
        const formattedValue = numValue.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        });
        return (
          <span style={{ color: 'var(--main-blue-color)' }}>
            {formattedValue}
          </span>
        );
      }
      if ((row.value === '0' || row.value === '1') && row.unit === '') {
        return <StatusIndicatorComponent status={row.value as '0' | '1'} />;
      }
      return (
        <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
      return null;
    }
  }
];

export const createFuelSystemRows = (initialData: any): TableRow[] => {
  if (!initialData?.valveCheck || !Array.isArray(initialData.valveCheck))
    return [];
  return initialData.valveCheck as TableRow[];
};

export const createStarterColumns = (
  StatusIndicatorComponent: React.ComponentType<{ status: '0' | '1' }>
): DataTableColumn<TableRow>[] => [
  {
    field: 'label',
    headerName: 'Parameter',
    width: 'auto',
    alignLeft: true,
    renderCell: ({ row }) => (
      <span style={{ fontWeight: '500', fontSize: '18px' }}>{row.label}</span>
    )
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    needPadding: row =>
      row.value !== '0' && row.value !== '1' && row.unit !== '',
    renderCell: ({ row }) => {
      const numValue = parseFloat(row.value as string);
      if (!isNaN(numValue)) {
        const formattedValue = numValue.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1
        });
        return (
          <span style={{ color: 'var(--main-blue-color)' }}>
            {formattedValue}
          </span>
        );
      }
      if ((row.value === '0' || row.value === '1') && row.unit === '') {
        return <StatusIndicatorComponent status={row.value as '0' | '1'} />;
      }
      return (
        <span style={{ color: 'var(--main-blue-color)' }}>{row.value}</span>
      );
    }
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 100,
    alignCenter: true,
    renderCell: ({ row }) => {
      if (row.unit) {
        return <span>{row.unit}</span>;
      }
      return null;
    }
  }
];

export const createStarterRows = (initialData: any[]): TableRow[] => {
  if (!initialData || !Array.isArray(initialData) || initialData.length === 0)
    return [];
  return initialData as TableRow[];
};
